var _PollingModelState_timeout;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import BaseModelState from './BaseModelState';
export default class PollingModelState extends BaseModelState {
    constructor(promiseOrValueFactory, timeout) {
        super();
        _PollingModelState_timeout.set(this, void 0);
        const worker = (async () => {
            this.setValue(await promiseOrValueFactory());
            __classPrivateFieldSet(this, _PollingModelState_timeout, setTimeout(worker, timeout), "f");
        }).bind(this);
        worker();
    }
    dispose() {
        if (__classPrivateFieldGet(this, _PollingModelState_timeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _PollingModelState_timeout, "f"));
        }
    }
}
_PollingModelState_timeout = new WeakMap();
